import { Icon } from 'components'
import styles from './styles.module.scss'

interface EmptyProps {
  title: string
  subtitle: string
}

const EmptyState = ({ title, subtitle }: EmptyProps) => (
  <div className={styles.emptyState}>
    <Icon color={'element-light'} name="empty-contact" width={62} height={66} />
    <h2>{title}</h2>
    <h3>{subtitle}</h3>
  </div>
)

export default EmptyState
